<template>
    <v-list density="compact">
        <v-list-item v-for="(tourists, index) in rooms" :key="index" :data-cy="'room-selector-' + index" class="d-flex">
            <v-list-item-title class="text-capitalize">{{ $t('room', 1) }} {{ index + 1 }}</v-list-item-title>
            <tourists-select
                :_adults="tourists.adults"
                :_children-ages="tourists.childrenAges"
                :max-total="maxTourists"
                @change-age="changeAge"
                @change-adults="tourists.adults = $event"
                @change-children-ages="tourists.childrenAges = $event"
            />
            <template v-slot:append>
                <v-list-item-action v-if="rooms.length > 1">
                    <v-btn variant="text" icon="mdi-close" size="small" @click="removeRoom(index)" />
                </v-list-item-action>
            </template>
        </v-list-item>
        <v-divider />
        <v-card-actions>
            <div class="flex-grow-1" />
            <v-btn variant="text" :disabled="isDisabled" @click="addRoom()">
                {{ $t('add_room') }}
            </v-btn>
            <slot />
        </v-card-actions>
    </v-list>
</template>

<script lang="ts">
    import {Component, Emit, Prop, VModel, Vue} from 'vue-facing-decorator'
    import TouristsSelect from '~src/components/search/forms/touristsSelect.src'

    @Component({
        components: {TouristsSelect},
    })
    export class RoomsSelectList extends Vue {
        @VModel() rooms
        @Prop({default: 9}) maxTourists

        @Emit()
        changeAge() {}

        addRoom() {
            this.rooms.push({adults: this.isDisabled ? 1 : 2, childrenAges: []})
        }

        removeRoom(index) {
            this.rooms.splice(index, 1)
        }

        get isDisabled() {
            return authStore.user.isEmployeeOrExternalCorp || this.rooms.length > 19
        }
    }

    export default RoomsSelectList
</script>
